<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4B15L/4B15L.jpg" alt=""></div>
      <div class="detail-banner-r">

        <div class="detail-banner-t2">4B15L 1.5T汽油发动机</div>
        <div class="detail-banner-desc">
          4B15L发动机是为满足更严格的油耗法规，更好的加速动态性能，实现更高性价比而开发的机型，因此具有性能高、动态响应快等特点；<br />
          4B15L发动机采用VGT增压器、350bar顶置直喷、缸盖集成排气歧管、DVVT、可变排量机油泵、热管理模块、米勒循环等先进技术。
        </div>

      </div>
    </div>
    <div class="detail-box">
      <div class="detail-title">核心参数</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大功率</div>
          <div class="detail-utils-u">130kW</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大扭矩</div>
          <div class="detail-utils-u">270N·m</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">热效率</div>
          <div class="detail-utils-u">37.5%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国6b</div>
        </div>

      </div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">VGT增压器</div>
          <div class="detail-four-desc">
            相比于普通电控废气旁通阀式增压器，VGT增压器拓宽了低速扭矩区间，动力响应性得到了明显的提升，同时改善了部分负荷和高速大负荷区域的燃油消耗率。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">350bar中置直喷</div>
          <div class="detail-four-desc">
            中置喷油器减少燃油湿壁，避免机油稀释。350bar燃油喷射系统有效减小油束直径，加快燃油雾化；可实现3次喷射，减少PN排放。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-2.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="detail-box detail-bottom-bgs">
      <!-- <div class="detail-title">低油耗</div>
					<div class="detail-desc">200 g/kW.h燃油消耗率，创造省油新高度</div> -->
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">缸盖集成排气歧管</div>
          <div class="detail-updown-desc">
            零部件数量减少有助于精简机构，重量降低23%，发动机排温可降低100℃左右。充分利用排气热量，迅速提高发动机冷却液温度，缩短暖机时间，降低油耗和排放。</div>
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">变排量机油泵</div>
          <div class="detail-updown-desc">
            可以根据发动机的转速和负荷调整机油压力，降低发动机0.5%～2%的燃油消耗，高转速工况最多能降低3%的燃油消耗。</div>
          <div class="img-box"><img src="/assets/product/engine/4B15L/4B15L-4.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="detail-swiper-list detail-box">
      <div class="sw-page swiper-pagination"></div>
      <div class="detail-swiper-left">
        <div class="detail-tabs">
          <div class="detail-tab-item active">
            <div class="detail-tab-title">热管理模块</div>
            <div class="detail-tab-desc">
              提高机油和缸套温度，降低摩擦功，从而降低油耗；提高低温环境下的机油温度，减轻机油稀释。冷启动下快速提升燃烧室缸壁温度，优化燃烧，降低排放；控制发动机全负荷工作时水温处于较低水平，减少早燃和爆震的发生。</div>
          </div>
          <div class="detail-tab-item">
            <div class="detail-tab-title">米勒循环</div>
            <div class="detail-tab-desc">
              通过进气门早关，增大节气门开度，降低泵气损失，改善中、小负荷经济性；使有效压缩比小于有效膨胀比，提升热效率，降低油耗；配合VGT增压器，有效降低爆震倾向，改善油耗。</div>
          </div>
        </div>
      </div>
      <div class="detail-swiper-right swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15L/4B15L-5.jpg" alt=""></div>
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15L/4B15L-6.jpg" alt=""></div>
        </div>
      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
        pagination: {
          el: '.sw-page',
          clickable: true,
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const tabItems = document.querySelectorAll('.detail-tab-item');
            tabItems.forEach((item, index) => {
              if (index === activeIndex) {
                item.classList.add('active');
              } else {
                item.classList.remove('active');
              }
            });
          },
        },
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4B15L 1.5T汽油发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4B15L.html'
};

import { createApp } from 'vue';
import App from './4B15L.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4B15L.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>